
(function () {
    'use strict';
    angular.module('tmx-app').controller('tradeRepositoryEditCtrl', ['$scope', '$rootScope', '$timeout', '$http', 'dynamicFormService', 'lookupService', 'resolvedData','TradeRepositoryService', 'tmxUtility', '$state', "$stateParams", 'ToastService', 'BroadcastService', "$mdDialog", "tmxResource", "cacheStore", "TMX_FINANCE_CONSTANTS",
        function TradeRepositoryEditCtrl($scope, $rootScope, $timeout, $http, dynamicFormService, lookupService, resolvedData,TradeRepositoryService, tmxUtility, $state, $stateParams, ToastService, BroadcastService, $mdDialog, tmxResource, cacheStore, TMX_FINANCE_CONSTANTS) {

            //#region  ========== Variables Declaration=============================
            var vm = this;
            var exists;
            var copy;
            var STATUS = {
                NEW: "New",
                UNKNOWN: "Unknown",
                DRAFT: "Draft"
            };
            var TenantsList = TMX_FINANCE_CONSTANTS.TENANTS;
            vm.tmxResource = tmxResource;
            vm.id = $stateParams.Id;
            vm.istabDisabled = false;
            exists = tmxUtility.exists;
            copy = tmxUtility.copy;
            var objectToArray = new Set();
            var rootKeys = [];
            var allFields = [];
            var objectToIterage = [];
            var objectKeys = [];
            var keyThatAreActuallyObject = ["TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson", "TmxCustomerMaster[0].TmxECIBDetail[0].TmxeCIBDetailHistoryMap"];
            var vitasTenants = [TenantsList.VITAS, TenantsList.VITAS_EG, TenantsList.VITAS_LEB, TenantsList.VITAS_IRQ];
            var lkupType = TMX_FINANCE_CONSTANTS.LOOKUP_TYPES;
            vm.statuses = lookupService.getLocalLookupsByType(lkupType.APPLICATION_STATUS);
            vm.isPageLoading = false;
            vm.slsUpdated = false;
            vm.showCommentDialog = showCommentDialog;
            vm.showManualDeviationDialog = showManualDeviationDialog;
            vm.showEvaluationRulesDialog = showEvaluationRulesDialog;
            vm.applicationStatus = "UnKnown";
            vm.status = "Unknwon";
            vm.showEMIButton = false;
            vm.showTranslationButton = false;
            vm.showValidateButton = false;
            vm.showCreditButton = false;
            vm.showAccountButton = false;
            vm.showtransferInWallet = false;
            vm.disableL2Button = false;
            vm.showDisbursementButton = false;
            vm.hideValidateButton = false;
            vm.checkPermission = tmxUtility.checkPermission;
            vm.dynamicFormService = dynamicFormService;
            vm.errorType = 'dynamic';// two types of errors, dynamic: that resolve dynamically. static: that do not resolve dynmically. They stay on screen until submission.
            vm.bizRulesFailedFields = [];//none of the fields have biz rule violations at begining
            vm.errorControl = {
                watch: true,//switch to start watching(updates dynamically)
                show: true,//switch to show errors (red red kerdy ga har jagah :3)
                enable: true,//gloabl switch to turn on and of validation checkings
                validations: {//object to operate each validation individually
                    required: true,//only for new loan app and draft loan app, required checking must be disabled
                    maxlength: true,
                    minlength: true
                }
            };
            vm.peripherals = {
                mustFields: [],//fields that must be filled irresepective of state of loan app
                locals: {
                    getBranchIdOfUser: function () {
                        if (resolvedData.informationIconData) {
                            return resolvedData.informationIconData.data.CompanyBranchId;
                        }
                        else {
                            return resolvedData.responseData.tradeAppData.data.CompanyBranchId;
                        }
                    }
                }
            }

            var LoggedInTenant, tenantName = "";
            var VERIFICATION_STATE_ROLE = null;
            var LoggedInUserConfigurations = cacheStore.get("Configurations");
            vm.fillManadtory = true;
            vm.errorControl.validations.required = !vm.fillManadtory;
            vm.resetPermission=vm.checkPermission('Loan Application Reset Button');
            vm.showDownloadButton = true;
            //#endregion


            //#region  ============== Private functions=====================================
            function readConfigurations() {
                if (LoggedInUserConfigurations) {
                    LoggedInTenant = LoggedInUserConfigurations.filter(function (item) {
                        return item.ConfigurationKey == 'INTEGRATION_TENANT';
                    })[0];

                    VERIFICATION_STATE_ROLE = LoggedInUserConfigurations.filter(function (item) {
                        return item.ConfigurationKey == 'VERIFICATION_STATE_ROLE';
                    })[0];
                    vm.isCommentMandatory = tmxUtility.getConfigurationValue(LoggedInUserConfigurations, 'IS_SUBMISSION_COMMENT_MANDATORY', true);
                }
                tenantName = LoggedInTenant.ConfigurationValue ? LoggedInTenant.ConfigurationValue.toLowerCase() : "";
            }

            function removeUnwantedTabs(responsetradeAppData, tfs) {
                var loggedInUserRoleName = JSON.parse(localStorage.getItem('LoggedInUserPrivileges')).roles[Object.keys(JSON.parse(localStorage.getItem('LoggedInUserPrivileges')).roles)[0]].name.toLowerCase();
                if (VERIFICATION_STATE_ROLE && loggedInUserRoleName == VERIFICATION_STATE_ROLE.ConfigurationValue.toLowerCase()) {
                    var allowedTabsList = [];
                    var loggedInUserId = JSON.parse(localStorage.getItem("user")).Id;
                    allowedTabsList = responsetradeAppData.TmxApplicationChecklist.map(item => item.TabID).filter((value, index) => responsetradeAppData.TmxApplicationChecklist[index].UserID == loggedInUserId);
                    tfs.Tabs = tfs.Tabs.filter(function (item) {
                        return allowedTabsList.indexOf(item.TabId) > -1
                    });
                }
            }

            function loadData(responsetradeAppData, skipPageSchemaReload) {
                objectToArray = new Set();
                if (exists(resolvedData, "responseData.pageSchema.data")) {
                    vm.pageSchema = resolvedData.responseData.pageSchema.data;
                    tfsManipulation(vm.pageSchema[0]);
                    dynamicFormService.pageSchema = vm.pageSchema[0]; // To access raw schema in dynamic page
                    var status = null;
                    if (exists(responsetradeAppData) && exists(responsetradeAppData)) {
                        vm.applicationStatus = vm.statuses.find(function (item) { return item.LookupId == responsetradeAppData.ApplicationStatusLkp });
                        if (exists(status)) {
                            vm.applicationStatus = status.VisibleValue;
                        }
                    }
                    if (!skipPageSchemaReload) {
                        removeUnwantedTabs(responsetradeAppData, vm.pageSchema[0]);
                        vm.page = dynamicFormService.loadPage(vm.pageSchema[0], undefined, vm.errorControl, vm.peripherals);//load page from schema
                        vm.page.registerDependants();
                    }
                    var selectedTab = exists(vm.page, "selectedTab") ? vm.page.selectedTab : undefined;
                    if (exists(selectedTab) && selectedTab > 0) {
                        vm.page.selectedTabIndex = vm.page.tabs.findIndex(tab => tab.id == selectedTab);

                        if (vm.page.selectedTabIndex == 0) { // chosoy: 0th tab was appearing collapsed
                            $timeout(function () {
                                vm.page.tabs[vm.page.selectedTabIndex].isSelected = true;
                                vm.page.selectedTab = selectedTab;
                            });
                        }
                        else { // No timeout in this section to avoid glitch
                            vm.page.tabs[vm.page.selectedTabIndex].isSelected = true;
                            vm.page.selectedTab = selectedTab;
                        }
                    }
                    vm.page.fieldMap.all.forEach(function (field) { initQuestion(field, resolvedData.questions) });
                    if (vm.page.tabs.filter(function (tab) { return tab.title == 'Loan Checklist' }).length) {
                        vm.page.tabs.filter(function (tab) { return tab.title == 'Loan Checklist' })[0].config.cols = 2;//loan checklist must be 2 column layout
                    }

                    vm.page.tabs.filter(function (tab) { return tab.title == 'FATCA Form' || tab.title == 'Credit Score' }).forEach(function (tab) { tab.config.cols = 1; });

                    var applicationDate = null;
                    if (vm.page.fieldMap.tname['TmxTransaction']) {
                        applicationDate = vm.page.fieldMap.tname['TmxTransaction']['CreatedDate'];
                    }

                    if (exists(applicationDate) && !exists(applicationDate.value)) {
                        applicationDate.updateValue((new Date), vm.page.fieldMap.primaryKey);
                    }

                    if (exists(resolvedData, "responseData.tradeAppData.data")) {
                        if (exists(resolvedData, "informationIconData.data")) {//Information Icon fixes
                            copy(resolvedData.informationIconData.data, [], responsetradeAppData);
                            responsetradeAppData.TmxCompanyBranch = { BranchName: resolvedData.informationIconData.data.BranchName };
                        }
                        vm.tradeAppData = responsetradeAppData;
                        wrapTradeAppAttributes(vm.tradeAppData);

                        var loanProduct = [];
                        if (vm.page.fieldMap.tname['TmxTransaction']) {
                            loanProduct = vm.page.fieldMap.tname['TmxTransaction']['ProductId'];
                        }

                        if (exists(loanProduct)) {
                            if (loanProduct.otherValues) {
                                loanProduct.otherValues.push({
                                    name: "getServiceChargesFromProduct",
                                    decription: "get services charges for current product",
                                    func: function () {
                                        var product = vm.tradeAppData.TmxProduct ? vm.tradeAppData.TmxProduct : resolvedData.loanProduct;
                                        loanProduct.getServiceChargesFromProduct = product;
                                    }
                                });
                            }
                        }
                        if ($stateParams.Id == "-1") { //application not fetched from DB
                            vm.page.read(vm.tradeAppData, vm.page.fieldMap); //fill page with data

                        }
                        else if (vm.tradeAppData["TmxCustomerMaster"]) {
                            takeOutChild(vm.tradeAppData, vm.tradeAppData.TmxCustomerMaster, 'TmxCustomerMaster');
                            makeObjectToArray(vm.tradeAppData)
                            vm.page.read(vm.tradeAppData, vm.page.fieldMap);// fill the page object with initial loan application data
                            vm.commands = vm.tradeAppData.Commands;
                            if (exists(vm.commands))
                                vm.commands.forEach(function (command) {
                                    command.label = formatName(command.VisibleValue);
                                });//format commands if any
                        }
                        else {
                            vm.tradeAppData = new TradeRepositoryService();
                        }
                    }
                }
            }

            function setDataAndState() {
                if (resolvedData.responseData && resolvedData.responseData.tradeAppData && resolvedData.responseData.tradeAppData.data) {
                    loadData(resolvedData.responseData.tradeAppData.data);
                }


                if (exists($stateParams.callbackState)) {//page to return to when leaving this screen
                    vm.returnState = $stateParams.callbackState;
                }
                else {
                    vm.returnState = "^";//if nothing specified, move to parent state
                }

                vm.resource = copy(vm.tradeAppData);//vm.resource is the object we send to server for saving
                dynamicFormService.applicationData = vm.resource;
            }


            vm.downloadPDF = function () {
                vm.ResourceCopy = angular.copy(vm.resource);
                vm.page.write(vm.ResourceCopy, false);
                unwrapTradeAppAttributes(vm.ResourceCopy);
                vm.bindRootObjectsToChildObjects();
                makeArrayToObject(vm.ResourceCopy);
                vm.deleteEmptyObjects();
                objectCleaning(vm.ResourceCopy);
                SetChecklist();

                var templates = lookupService.getLocalLookupsByType(TMX_FINANCE_CONSTANTS.LOOKUP_TYPES.TRADE_TRN_PDF_TYPE);
                var templateToDownload = { templateName: 'Trade_Repository_HTML', pdfName: 'Trade_Repository.pdf' };
                if (exists(templates) && templates.length > 0) // Go in this case to set templates if there are value in lookups else use default values as defined above
                {
                    if (templates.length == 1) {
                        templateToDownload = {
                            templateName: templates[0].HiddenValue,
                            pdfName: templates[0].VisibleValue.endsWith('.pdf') ? templates[0].VisibleValue : templates[0].VisibleValue + '.pdf'
                        }
                    }
                    else {
                        showTemplateSelectionDialog(templates, function (selectedTemplate) {
                            if (!exists(selectedTemplate)) {
                                return;
                            }
                            templateToDownload = {
                                templateName: selectedTemplate.HiddenValue,
                                pdfName: selectedTemplate.VisibleValue.endsWith('.pdf') ? templates[0].VisibleValue : selectedTemplate.VisibleValue + '.pdf'
                            };
                            $http.put(APP_CONSTANTS.backend + 'Transaction/DownloadApplicationPDF/' + templateToDownload.templateName, vm.ResourceCopy, { responseType: 'arraybuffer' }).success(function (data) {
                                var file = new Blob([data], { type: 'application/pdf' });
                                saveAs(file, templateToDownload.pdfName);
                            });
                        }, function () { });

                        return; /// return from original function
                    }
                }

                $http.put(APP_CONSTANTS.backend + 'Transaction/DownloadApplicationPDF/' + templateToDownload.templateName, vm.ResourceCopy, { responseType: 'arraybuffer' }).success(function (data) {
                    var file = new Blob([data], { type: 'application/pdf' });
                    saveAs(file, templateToDownload.pdfName);
                });
            }

            function showTemplateSelectionDialog(data, successcb, errorcb) {
                $mdDialog.show({
                    controller: ['$scope', '$mdDialog', 'data', TemplateSelectionDialogCtrl],
                    templateUrl: 'app/private/transaction/pdf-template-selection-dialog.html',
                    parent: angular.element(document.body),
                    locals: {
                        data: data
                    },
                    clickOutsideToClose: true,
                    fullscreen: true,
                })
                    .then(function (templateObj) {
                        successcb(templateObj)
                    }, function () {
                        errorcb();
                    });
            }

            function TemplateSelectionDialogCtrl($scope, $mdDialog, data) {
                $scope.templateLookups = data;
                $scope.selectedTemplateId = null;
                var selectedTemplate = $scope.templateLookups[0];
                $scope.done = function () {
                    if ($scope.selectedTemplateId != null && $scope.selectedTemplateId != undefined) {
                        selectedTemplate = $scope.templateLookups.find(x => x.LookupId == $scope.selectedTemplateId);
                        $mdDialog.hide(selectedTemplate);
                    }
                }
                $scope.cancel = function () {
                    $mdDialog.hide();
                }
            }

            function showEvaluationRulesDialog(evaluationData, showOnlyMessages) {
                $mdDialog.show({
                    controller: ['$scope', '$mdDialog', '$filter', 'evaluationData', 'lookupService', 'UsersService', 'showOnlyMessages', 'tenantName', 'TenantsList', EvaluationRulesDialogController],
                    locals: { evaluationData: evaluationData, showOnlyMessages: showOnlyMessages, tenantName: tenantName, TenantsList: TenantsList },
                    templateUrl: 'app/private/transaction/trade-repository/edit/evaluation-rule-dialog.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
                })
                    .then(function (responseData) {

                        if (responseData) {
                            vm.isPageLoading = true;
                            var ProcessInstanceID = vm.tradeAppData.ProcessInstanceId;
                            var action = "ExecuteWf";
                            (function () {
                                var data = {
                                    "Parameter": '',
                                    "Command": 'DeviationApproval',
                                    "TargetUserId": responseData.TargetUserId,
                                    "rule": evaluationData.data,
                                    "UserId": JSON.parse(localStorage.getItem("user")).Id,
                                    "ProcessID": ProcessInstanceID,
                                    "ApplicationId": vm.tradeAppData.TransactionId,
                                    "TmxApplicationRemark": responseData.TmxApplicationRemark
                                }
                                TradeRepositoryService.getByAction(action, true, "put", data).then(function () {
                                    vm.isPageLoading = false;
                                    $state.go("private.inbox");
                                });
                            })();
                        }
                    }, function () {

                    });
            }

            function showManualDeviationDialog(command, ParameterName, ev) {
                var loggedInUserId = JSON.parse(localStorage.getItem("user")).Id;
                var TransactionID = vm.tradeAppData.TransactionId;
                $mdDialog.show({
                    controller: ['$scope', '$mdDialog', '$filter', 'lookupService', 'UsersService', ManualDeviationDialogController],
                    templateUrl: 'app/private/transaction/trade-repository/edit/manual-deviation-dialog.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: $scope.customFullscreen, // Only for -xs, -sm breakpoints.
                    locals: { ApplicationId: TransactionID, UserId: loggedInUserId },
                })
                    .then(function () {
                        vm.isPageLoading = true;
                        var ProcessInstanceID = vm.tradeAppData.ProcessInstanceId;
                        var action = "ExecuteWf";
                        vm.save(function () {

                            var data = {
                                "Parameter": ParameterName,
                                "Command": command,
                                "ProcessID": ProcessInstanceID,
                                "ApplicationId": TransactionID,
                                "UserId": loggedInUserId,
                            }

                            TradeRepositoryService.getByAction(action, true, "put", data).then(function (response) {
                                vm.isPageLoading = false;
                                if (response.data.status) {
                                    if (response.data.status.code < 400) {
                                        $state.go("private.inbox");
                                    }
                                    else {
                                        showEvaluationRulesDialog(response.data.data);
                                    }
                                }

                            });
                        });


                    }, function () {

                    });
            }

            function showCommentDialog(commandObj, ev) {
                let command = commandObj.HiddenValue;
                let ParameterName = commandObj.ParameterName;
                let receivingActors = commandObj.TmxWorkflowReceivingActor;
                var TransactionID = vm.tradeAppData.TransactionId;
                var ProcessInstanceID = vm.tradeAppData.ProcessInstanceId;
                var loggedInUserId = JSON.parse(localStorage.getItem("user")).Id;
                $mdDialog.show({
                    controller: ['$scope', '$mdDialog', '$filter', 'TMX_FINANCE_CONSTANTS', 'tmxUtility', 'UsersService', 'lookupService', 'ToastService', 'command', 'Parameter', 'Actors', 'ProcessID', 'ApplicationId', 'UserId', 'TenantName', CommentsDialogController],
                    locals: { command: command, Parameter: ParameterName, Actors: receivingActors, ProcessID: ProcessInstanceID, ApplicationId: TransactionID, UserId: loggedInUserId, TenantName: tenantName },
                    templateUrl: 'app/private/transaction/trade-repository/edit/comment-dialog.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
                })
                    .then(function (responseData) {

                        vm.isPageLoading = true;

                        var action = "ExecuteWf";
                        vm.save(function () {

                            if (vm.saveSuccess >= 400) {
                                vm.isPageLoading = false;
                                return;
                            }


                            var data = {
                                "Parameter": ParameterName,
                                "Command": command,
                                "ProcessID": ProcessInstanceID,
                                "ApplicationId": TransactionID,
                                "UserId": loggedInUserId,
                                "TmxApplicationRemark": responseData.TmxApplicationRemark,
                                "TmxWorkflowReceivingActor": responseData.TmxWorkflowReceivingActor
                            }
                            TradeRepositoryService.getByAction(action, false, "put", data).then(function (response) {
                                vm.isPageLoading = false;
                                if (response.data && response.data != null) {

                                    if (response.data.status && response.data.status.code == 417) {
                                        let validationText = "";
                                        if (exists(response.data.data) && exists(response.data.data.Errors) && response.data.data.Errors.length > 0) {
                                            response.data.data.Errors.forEach(function (val) {
                                                validationText += val + "<br>";
                                            });
                                        }
                                        vm.showSimpleDialog("Validation Rules", validationText);

                                        if (response.data.data.model) {
                                            var tmxResource = vm.tmxResource('Transaction');
                                            vm.resource = tmxResource.createResourceObject(response.data.data.model);
                                            vm.tradeAppData = angular.copy(vm.resource);
                                            dynamicFormService.applicationData = vm.resource;
                                            loadData(vm.resource);
                                        }

                                    }
                                    else if (response.data.manualDeviation || exists(response.data.data, 'manualDeviation')) {
                                        if (!exists(response.data.manualDeviation)) { // In some cases deviations is coming inside data so handling that case
                                            response.data.manualDeviation = response.data.data.manualDeviation;
                                        }
                                        showDeviationDialog(response);
                                    }
                                    else if (response.data.error || exists(response.data.data, 'error')) {
                                        if (!exists(response.data.error)) { // In some cases error is coming inside data so handling that case
                                            response.data.error = response.data.data.error;
                                        }
                                        showDeviationDialog(response);
                                    }
                                    else if (response.data.warning || exists(response.data.data, 'warning')) {
                                        if (!exists(response.data.warning)) { // In some cases warning is coming inside data so handling that case
                                            response.data.warning = response.data.data.warning;
                                        }
                                        showDeviationDialog(response);
                                    }
                                    else if (exists(response.data.wFDeviation) || exists(response.data.data, 'wFDeviation')) {
                                        if (!exists(response.data.wFDeviation)) { // In some cases wf deviations is coming inside data so handling that case
                                            response.data.wFDeviation = response.data.data.wFDeviation;
                                        }
                                        let validationText = "";
                                        if (exists(response.data.wFDeviation) && response.data.wFDeviation.length > 0) {
                                            response.data.wFDeviation.forEach(function (val, index) {
                                                validationText += index + 1 + ') ' + val + "<br>";
                                            });
                                        }
                                        vm.showSimpleDialog("WorkFlow Deviation(s)", validationText, function () {
                                            $state.go("private.inbox");
                                        });
                                    }
                                    else {
                                        $state.go("private.inbox");
                                    }
                                }
                                else {
                                    $state.go("private.inbox");
                                }
                            });
                        });

                    }, function () {

                    });

                function showDeviationDialog(response) {
                    if (response.data && !exists(response.data.data)) {
                        var data = response.data;
                        response.data = {};
                        response.data.data = {};
                        response.data.data = data;
                    }
                    showEvaluationRulesDialog(response.data.data);
                    dynamicFormService.applicationData = vm.resource;
                    vm.errorControl.validations.required = false;
                    loadData(vm.resource, true);
                }
            }


            function formatJsonForPost() {
                unwrapTradeAppAttributes(vm.ResourceCopy);
                vm.bindRootObjectsToChildObjects();
                makeArrayToObject(vm.ResourceCopy);
                vm.deleteEmptyObjects();
                objectCleaning(vm.ResourceCopy);
                SetChecklist();
            }

            function SetChecklist() {
                if (exists(vm.ResourceCopy.TmxApplicationChecklist)) {
                    vm.ResourceCopy.TmxApplicationChecklist.forEach(function (item) {
                        if (item.Attachment) {
                            item.MimeType = "";
                            if (item.Attachment.includes('data:image/jpeg;base64')) {
                                item.MimeType = "image/png";
                            }
                            else if (item.Attachment.includes('data:application/pdf;base64')) {
                                item.MimeType = "application/pdf";
                            }
                            else if (item.Attachment.includes('data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64')) {
                                item.MimeType = "application/xlsx";
                            }
                            else if (item.Attachment.includes('data:image/tiff;base64')) {
                                item.MimeType = "image/tiff";
                            }
                            else if (item.Attachment.includes('data:application/msword;base64')) {
                                item.MimeType = "application/msword";
                            }
                            item.Attachment = item.Attachment.replace('data:image/jpeg;base64,', '').replace('data:application/pdf;base64,', '').replace('data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,', '').replace('data:image/tiff;base64,', '').replace('data:application/msword;base64,', '');
                        }
                    });
                }
            }


            function tenantWiseLogic() {
                
            }

            function setButtonsVisiblity() {
                var validateButtonHiddenStatuses = tmxUtility.getConfigurationValue(LoggedInUserConfigurations, 'HIDE_VALIDATION_ON_STATUS')
                if (exists(validateButtonHiddenStatuses)) {
                    var statusList = validateButtonHiddenStatuses.split(',');
                    if (statusList.indexOf(vm.getStatus()) > -1) {
                        vm.hideValidateButton = true;
                    }
                }

                if (tmxUtility.checkPermission('Validate Service', 'View') && !vm.hideValidateButton) {
                    if (vitasTenants.includes(tenantName)) {
                        vm.disableActionButton1 = true;
                        vm.disableActionButton2 = true;
                    }
                    else if (TenantsList.SAMBA == tenantName || TenantsList.UBANK == tenantName) { //Ubank check added by Adeel 07-01-2020
                        vm.disableActionButton1 = true;
                    }
                }

                vm.showDownloadButton = tmxUtility.checkPermission('Download PDF Button', 'View');
            }

            function setStatusBasedVariables() {
                if(vm.id != -1) { //When loading screen without saving application
                switch (vm.getStatus()) {
                    case STATUS.NEW:
                    case STATUS.DRAFT:
                        vm.peripherals.mustFields.forEach(function (id) {
                            var field = vm.page.fieldMap.primaryKey["tf" + id];
                            if (exists(field)) {//if the must field exists
                                field.errorControl = {
                                    watch: true,//switch to start watching(updates dynamically)
                                    show: true,//switch to show errors (red red kerdy ga har jagah :3)
                                    enable: true,//gloabl switch to turn on and of validation checkings
                                    validations: {//object to operate each validation individually
                                        required: true,
                                        maxlength: true,
                                        minlength: true
                                    }
                                }
                            }
                        });
                        vm.verifyPage();
                        break;
                    default:
                        break;
                }
            }
            }


            function formatName(name) {
                var arr = name.split(/(?=[A-Z])/);
                var result = "";
                arr.forEach(function (token, index) {
                    result += token;
                    if (index < arr.length - 1) {
                        result += " ";
                    }
                });
                return result;
            }

            function wrapTradeAppAttributes(resource) {
                resource.TmxTransaction = [];
                resource.TmxTransaction[0] = {};
                for (var key in resource) {
                    if (resource.hasOwnProperty(key)) {
                        if (typeof resource[key] !== 'object') {
                            resource.TmxTransaction[0][key] = resource[key];
                        }

                    }
                }
            }


            function unwrapTradeAppAttributes(resource) {
                if (resource.TmxTransaction[0]) {
                    var insideAttributes = Object.getOwnPropertyNames(resource.TmxTransaction[0]);
                    insideAttributes.forEach(item => {
                        resource[item] = resource.TmxTransaction[0][item];
                    });
                    delete resource.TmxTransaction;
                }

            }

            function takeOutChild(rootObject, objectToTraverse, name = null) {

                if (!exists(objectKeys)) {
                    objectKeys = [];
                }
                if (!exists(objectToTraverse)) return;
                if (Object.prototype.toString.call(objectToTraverse) == '[object Object]') {
                    Object.keys(objectToTraverse).forEach(function (key) {
                        if (Object.prototype.toString.call(objectToTraverse[key]) == '[object Object]' || Object.prototype.toString.call(objectToTraverse[key]) == '[object Array]') {
                            var rootObjectKey;
                            rootObjectKey = name + "." + key;

                            if (Object.prototype.toString.call(objectToTraverse[key]) == '[object Object]') {
                                rootObject[rootObjectKey] = [];
                                rootObject[rootObjectKey][0] = objectToTraverse[key];
                                if (objectKeys.indexOf(rootObjectKey) < 0) {
                                    objectKeys.push(rootObjectKey)
                                }
                            }
                            else {
                                rootObject[rootObjectKey] = objectToTraverse[key];
                            }
                            takeOutChild(rootObject, objectToTraverse[key], rootObjectKey);
                        }
                    });
                }
                else if (Object.prototype.toString.call(objectToTraverse) == '[object Array]') {
                    for (var i = 0; i < objectToTraverse.length; i++) {
                        takeOutChild(rootObject, objectToTraverse[i], name + "[" + i + "]");
                    }
                }
            }

            function objectCleaning(resourceObject) {
                if (resourceObject) {
                    var Obj = resourceObject
                    Object.keys(Obj).forEach(function (objectKey) {
                        if (Object.prototype.toString.call(Obj[objectKey]) == '[object Array]') {
                            Obj[objectKey].forEach(function (innerObject, index) {

                                for (var key in innerObject) {
                                    if (!angular.isDefined(innerObject[key])) {
                                        delete innerObject[key];
                                    }
                                }

                                if (innerObject && Object.getOwnPropertyNames(innerObject).length < 1) {
                                    Obj[objectKey].splice(index, 1);
                                }
                                else {
                                    objectCleaning(innerObject);
                                }
                            })
                        }
                    });
                }
            }

            function tfsManipulation(tfsObject) {
                angular.forEach(tfsObject.Tabs, function (item) {
                    angular.forEach(item.Fields, function (obj) {
                        allFields.push(obj)
                    })
                })

                objectToIterage = angular.copy(allFields);

                angular.forEach(allFields, function (item) {
                    if (!item.FieldTableName.includes('.')) {
                        try {
                            item.FieldTableName = renameTableName(item);
                        }
                        catch (e) {
                            console.error(e);
                            console.error('Error in field definition', item);
                        }
                    }
                })
            }

            function renameTableName(item) {
                var newParentId = 0;
                var fieldTableName = item.FieldTableName;

                if (item._ParentFieldId) {
                    newParentId = objectToIterage.filter(obj => obj.TenantFieldSetupId == item._ParentFieldId)[0]._ParentFieldId;
                    if (objectToIterage.filter(obj => obj.TenantFieldSetupId == item._ParentFieldId)[0].FieldTableName.includes('[]')) {
                        var tableName = angular.copy(objectToIterage.filter(obj => obj.TenantFieldSetupId == item._ParentFieldId)[0].FieldTableName.replace('[]', ''));
                        fieldTableName = tableName + '[0].' + item.FieldTableName.replace('[]', '');
                    }
                    else {
                        fieldTableName = objectToIterage.filter(obj => obj.TenantFieldSetupId == item._ParentFieldId)[0].FieldTableName + '.' + item.FieldTableName.replace('[]', '');
                    }
                }


                while (newParentId) {
                    var baseObj = objectToIterage.filter(obj => obj.TenantFieldSetupId == newParentId)[0].FieldName;
                    if (baseObj == 'TmxPerson') {
                        fieldTableName = baseObj + '.' + fieldTableName;
                    }
                    else {
                        fieldTableName = baseObj + '[0].' + fieldTableName;
                    }

                    newParentId = objectToIterage.filter(obj => obj.TenantFieldSetupId == newParentId)[0]._ParentFieldId
                }


                var FinalName = fieldTableName.replace('TmxTransaction[0].', '');
                FinalName = FinalName.replace('TmxTransaction.', '');
                return FinalName;
            }

            function makeObjectToArray(rootObject) {
                objectToArray.add('TmxCustomerMaster[0].TmxECIBDetail[0].TmxeCIBDetailHistoryMap');
                objectToArray.add('TmxCompanyBranch');
                objectToArray.add('TmxProduct');
                objectToArray.add('TmxUser');
                objectToArray.add('TmxUserRoleMapping');
                Object.keys(rootObject).forEach(function (key) {
                    if (Object.prototype.toString.call(rootObject[key]) == '[object Object]') {
                        objectToArray.add(key);
                        var tempObj = angular.copy(rootObject[key]);
                        rootObject[key] = [];
                        rootObject[key][0] = tempObj;
                    }
                });
            }

            function makeArrayToObject(rootObject) {
                objectToArray.forEach(function (key) {
                    if (Object.prototype.toString.call(rootObject[key]) == '[object Array]') {
                        var tempObj = angular.copy(rootObject[key][0]);
                        rootObject[key] = {};
                        rootObject[key] = tempObj;
                    }
                });
            }

            function initQuestion(field, questions) {
                if (field.type == 'question') {
                    if (exists(questions[field.tableObj.tname], "data"))
                        field.setQuestion(questions[field.tableObj.tname].data);
                }
            }

            //#endregion


            //#region  ========== Scope functions ============================


            vm.print = function (ev) {
                if (exists(vm.page)) {
                    if (exists(vm.resource) && exists(vm.resource.TmxCustomerMaster) && exists(vm.resource.TmxCustomerMaster[0])) {
                        var CustomerMasterId = vm.resource.TmxCustomerMaster[0].CustomerMasterId;
                        var CustomerName = vm.resource.TmxCustomerMaster[0].CustomerName;
                    }
                    if (exists(vm.resource) && exists(vm.resource.TmxProduct) && angular.isDefined(vm.resource.TmxProduct.ProductName)) {
                        var ProductName = vm.resource.TmxProduct.ProductName;
                        var ProductId = vm.resource.TmxProduct.ProductId;
                    }
                    vm.ResourceCopy = angular.copy(vm.resource);
                    vm.tradeAppDataCopy = angular.copy(vm.tradeAppData);
                    vm.mapresource();

                    $mdDialog.show({
                        controller: 'PrintCtrl',
                        templateUrl: 'app/private/transaction/trade-repository/edit/Print.html',
                        parent: angular.element(document.body),
                        targetEvent: ev,
                        locals: {
                            page: angular.copy(vm.page),
                            data: vm.ResourceCopy,
                            CustomerId: CustomerMasterId,
                            ProductName: ProductName,
                            ProductId: ProductId,
                            CustomerName: CustomerName,
                            getVisibleValue: vm.getVisibleValue,
                            signatureCaptured: vm.signatureCaptured,
                            tradeAppData: vm.tradeAppData
                        },
                        clickOutsideToClose: true,
                        fullscreen: true,
                    })
                        .then(function () {

                        }, function () {

                        });

                }
            }


            vm.evaluateRule = function () {
                vm.isPageLoading = true;
                vm.ResourceCopy = angular.copy(vm.resource);
                vm.tradeAppDataCopy = angular.copy(vm.tradeAppData);
                vm.page.write(vm.ResourceCopy, false);
                formatJsonForPost();

                tmxResource('TradeRepository').getByAction('EvaluateRules', false, 'put', vm.ResourceCopy).then(function (response) {
                    vm.isPageLoading = false;
                    if (response.data && !exists(response.data.data)) {
                        var data = response.data;
                        response.data = {};
                        response.data.data = {};
                        response.data.data = data;
                    }
                    if (response.data && response.data.data && (response.data.data.manualDeviation || response.data.data.warning || response.data.data.error || response.data.data.data))
                        showEvaluationRulesDialog(response.data.data, true);
                    else
                        ToastService.showCustomToast('success', 'No rule is voilated & no Deviation/Warning occurred.');
                    // if (response.data.data) {
                    //     showEvaluationRulesDialog(response.data.data, true);
                    // }
                });
            }

            vm.showSimpleDialog = function (title, message, callback) {
                var alertConfig = {
                    title: title,
                    htmlContent: message,
                    ok: 'Close'
                };
                var alert = $mdDialog.alert(alertConfig);
                $mdDialog
                    .show(alert)
                    .finally(function () {
                        alert = undefined;
                        if (exists(callback)) callback();
                    });
            }

            vm.verifyPage = function () {
                vm.page.verify(function () {
                });
            }

            vm.translateValues = function () {
                var DictAddress = vm.page.fieldMap.all.filter(function (item) { return item.form_name == 'TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson_CustPR' });

                var City = vm.page.fieldMap.all.filter(function (item) { return item.form_name == 'TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson_CustTown' });
                var Area = vm.page.fieldMap.all.filter(function (item) { return item.form_name == 'TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson_CustDistrict' });
                var Suburb = vm.page.fieldMap.all.filter(function (item) { return item.form_name == 'TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson_CustCaza' });
                var AddressArabic = vm.page.fieldMap.all.filter(function (item) { return item.form_name == 'TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson_CustPRArabic' });


                var AddressLocation = DictAddress ? DictAddress[0].value : false;
                var LocationLookupId = Suburb ? Suburb[0].value : false;


                var body = {
                    "DictAddress": AddressLocation ? AddressLocation : null,
                    "LocationLookupId": LocationLookupId ? LocationLookupId : null
                }

                if (AddressLocation || LocationLookupId) {
                    tmxResource("Integration").getByAction("TranslateModelValues", false, 'post', body).then(function (response) {
                        if (response.status.code == 200) {
                            if (AddressArabic[0]) {
                                AddressArabic[0].value = response.data.AddressArabic;
                                DictAddress[0].value = response.data.DictAddress;
                            }
                            if (exists(response.data.AddressLocation)) {
                                if (City[0]) {
                                    City[0].value = response.data.AddressLocation.City;//tmxUtility.getPropertyValue(lookupService.getLookupById(response.data.AddressLocation.City),"VisibleValue");
                                }
                                if (Area[0]) {
                                    Area[0].value = response.data.AddressLocation.Area;// tmxUtility.getPropertyValue(lookupService.getLookupById(response.data.AddressLocation.Area),"VisibleValue");
                                }
                                if (Suburb[0]) {
                                    Suburb[0].value = response.data.AddressLocation.Suburb; // tmxUtility.getPropertyValue(lookupService.getLookupById(response.data.AddressLocation.Suburb),"VisibleValue");
                                }

                            }
                        }

                    })
                }
                else {
                    ToastService.showCustomToast("default", "Please select an address to translate.");
                }
            }

            vm.validateEntity = function () {
                var fillManadtory = vm.getStatus() == STATUS.NEW || vm.getStatus() == STATUS.DRAFT;
                vm.ResourceCopy = angular.copy(vm.resource);
                vm.tradeAppDataCopy = angular.copy(vm.tradeAppData);
                vm.page.write(vm.ResourceCopy, fillManadtory);
                formatJsonForPost();

                tmxResource("Integration").getByAction("ValidateEntity", false, 'post', vm.ResourceCopy).then(function (response) {
                    if (!exists(response)) {
                        ToastService.showCustomToast("default", "Error in calling the service");
                        return;
                    }
                    if (response.status.code == 200) {
                        if (response.data.Success == true) {
                            vm.disableActionButton1 = false;
                            vm.disableActionButton2 = false;
                            ToastService.showCustomToast("success", "Validation successful.");

                        }
                        else {
                            var validationText = "";
                            if (exists(response.data) && response.data.Errors.length > 0) {
                                response.data.Errors.forEach(function (val) {
                                    validationText += val + "<br>";
                                });
                            }
                            vm.showSimpleDialog("Validation Rules", validationText);
                        }
                    }
                    else {
                        ToastService.showCustomToast("default", response.status.message);
                    }
                });

            }

            vm.downloadCreditReport = function () {
                var fillManadtory = vm.getStatus() == STATUS.NEW || vm.getStatus() == STATUS.DRAFT;
                vm.ResourceCopy = angular.copy(vm.resource);
                vm.tradeAppDataCopy = angular.copy(vm.tradeAppData);
                vm.page.write(vm.ResourceCopy, fillManadtory);
                formatJsonForPost();

                $http.put(APP_CONSTANTS.backend + 'Integration/CreditReport', vm.ResourceCopy, { responseType: 'arraybuffer' }).success(function (response) {
                    //tmxResource("Integration").getByAction("CreditReport", false, 'put', vm.ResourceCopy).then(function (response) {
                    if (response == "") {
                        ToastService.showCustomToast("default", "No data returned");
                    }
                    else {

                        var file = new Blob([response], { type: 'application/pdf' });
                        if (file.size != 0) {
                            saveAs(file, "Credit Report.pdf");
                        }

                        else {
                            ToastService.showCustomToast("default", "Error occured in generating the credit report, check logs for details.");
                        }
                    }

                });

            }

            vm.formChange = function () {
                if (vitasTenants.includes(tenantName) && tmxUtility.checkPermission('Validate Service', 'View') && !vm.hideValidateButton) {
                    vm.disableActionButton1 = true;
                    vm.disableActionButton2 = true;
                }
                else if (TenantsList.SAMBA == tenantName && tmxUtility.checkPermission('Validate Service', 'View')) {
                    vm.disableActionButton1 = true;
                }
            }

            vm.saveAndLeave = function () {
                vm.isPageLoading = true;
                vm.errorControl.validations.required = false;
                vm.removeViolatedBizRules();
                vm.errorType = 'dynamic';
                vm.save(function () {
                    dynamicFormService.applicationData = vm.resource;
                    loadData(vm.resource, true);
                    vm.isPageLoading = false;
                });
            }

            vm.save = function (callback) {
                if (exists(vm.page)) {
                    var fillManadtory = vm.getStatus() == STATUS.NEW || vm.getStatus() == STATUS.DRAFT;
                    vm.ResourceCopy = angular.copy(vm.resource);
                    vm.tradeAppDataCopy = angular.copy(vm.tradeAppData);

                    vm.page.write(vm.ResourceCopy, fillManadtory);
                    formatJsonForPost();
                    vm.verifyPage();

                    if (!vm.page.isValid) {
                        vm.isPageLoading = false;
                        var alert = {
                            title: 'Save Failed Due To Invalid Fields',
                            message: 'Application could not proceed to save due to some invalid fields. Please rectify the invalid fields in order to be able to save the Loan Application.',
                        };
                        vm.showSimpleDialog(alert.title, alert.message);
                        return;//don't proceed with saving
                    }
                    // vm.ResourceCopy.TmxLoanApplicationToGuarantorMapping = TmxLoanApplicationToGuarantorMappingArrayToObjectConversion(dynamicFormService.applicationGuarantorMappingData);

                    vm.ResourceCopy.$saveOrUpdate().then(function (response) {

                        if(!response || response.status < 0){ // In case of network error
                            vm.isPageLoading = false;
                            ToastService.showCustomToast("default", "Unable to save the transaction, no response received from server.");
                            return;
                        }
                        if (response.status > 200) {
                            vm.isPageLoading = false;
                            if(response.status > 500){
                                ToastService.showCustomToast("default", "Unable to save the transaction, an error occurred on server.");
                            }
                            else {
                                ToastService.showCustomToast("default", "Unable to save the transaction.");
                            }
                            console.error("Error in saving application, response from server: ",response);
                            return;
                        }
                        vm.resource = response.data;


                        var responseStatusCode = response.status.code != undefined ? response.status.code : response.status;
                        // eslint-disable-next-line no-unused-vars
                        var responseStatus;
                        vm.saveSuccess = responseStatusCode;
                        if (exists(response)) {
                            switch (responseStatusCode) {
                                case 200:
                                case 201:
                                case 202:
                                    responseStatus = "success";
                                    break;
                                default:
                                    responseStatus = "error";
                            }
                        }
                        else {
                            ToastService.showCustomToast("default", "Application saving failed due to unknown error");
                        }
                        callback();
                    });
                }
            }

            vm.reset = function () {
                if (exists(vm.page) && exists(vm.tradeAppData)) {
                    vm.page.read(vm.tradeAppData);
                    $(".k-datetimepicker input").val('');
                }
            }

            vm.bindRootObjectsToChildObjects = function () {

                rootKeys = Object.getOwnPropertyNames(vm.ResourceCopy);
                rootKeys = rootKeys.filter(function (item) {
                    return item.includes(".");
                })
                rootKeys.forEach(item => {
                    if (Object.prototype.toString.call(vm.ResourceCopy[item]) === "[object Object]" && vm.ResourceCopy[item].type) {
                        vm.ResourceCopy[item] = JSON.parse(kendo.stringify(vm.ResourceCopy[item]))
                    }
                    if (Object.prototype.toString.call(vm.ResourceCopy[item]) === '[object Array]' && objectKeys.indexOf(item) < 0 && !(keyThatAreActuallyObject.indexOf(item) > -1)) {

                        try {
                            /*jshint evil:true */
                            eval("vm.ResourceCopy." + item + " = vm.ResourceCopy[item]");
                        }
                        catch (exception) {
                            console.log('Error Occured In Evaluating ' + item);
                        }
                    }
                    else if (Object.prototype.toString.call(vm.ResourceCopy[item]) === '[object Array]' && (objectKeys.indexOf(item) > 0 || keyThatAreActuallyObject.indexOf(item) > -1)) {
                        if (vm.ResourceCopy[item][0]) {
                            try {
                                /*jshint evil:true */
                                eval("vm.ResourceCopy." + item + " = vm.ResourceCopy[item][0]");
                            }
                            catch (exception) {
                                console.log('Error Occured In Evaluating ' + item);
                            }
                        }
                    }
                });
            }
            vm.deleteEmptyObjects = function () {

                rootKeys.forEach(function (item) {
                    delete vm.ResourceCopy[item];
                });
            }

            vm.mapresource = function () {

                // vm.ResourceCopy.TmxLoanApplicationToGuarantorMapping = vm.tradeAppDataCopy.TmxLoanApplicationToGuarantorMapping;
                // vm.ResourceCopy.TmxLoanAppToGuarantorMpg = vm.tradeAppDataCopy.TmxLoanAppToGuarantorMpg;
                vm.ResourceCopy.TmxCustomerMaster[0].negarea = vm.tradeAppDataCopy.TmxCustomerMaster[0].negarea;
                vm.ResourceCopy.TmxCustomerMaster[0].negcustomer = vm.tradeAppDataCopy.TmxCustomerMaster[0].negcustomer;
                if (angular.isDefined(vm.ResourceCopy.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail) &&
                    angular.isDefined(vm.ResourceCopy.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0]) &&
                    angular.isDefined(vm.tradeAppDataCopy.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail) &&
                    angular.isDefined(vm.tradeAppDataCopy.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0]) && TenantsList.SILK == tenantName) {
                    vm.ResourceCopy.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].NatureOfBusiness = vm.tradeAppDataCopy.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].NatureOfBusiness;
                    vm.ResourceCopy.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].NameOfEmployer = vm.tradeAppDataCopy.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].NameOfEmployer;
                }
                vm.ResourceCopy.TmxCustomerMaster[0].FRMUStatus = vm.tradeAppDataCopy.TmxCustomerMaster[0].FRMUStatus;
                vm.ResourceCopy.TmxCustomerMaster[0].SLSStatus = vm.tradeAppDataCopy.TmxCustomerMaster[0].SLSStatus;
                vm.ResourceCopy.TmxCustomerMaster[0].PerAddressLine3UDF = vm.tradeAppDataCopy.TmxCustomerMaster[0].PerAddressLine3UDF;

                var data = lookupService.getLocalLookupsByType(lkupType.ID_TYPE)
                if (data) {
                    data.filter(function (item) {
                        if (item.VisibleValue == "NIC Number (ID-N)")
                            vm.cnicLookupId = item.LookupId;
                    });
                }

                vm.cnicData = vm.tradeAppDataCopy.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonNationalIdentifier.filter(function (item) {
                    return item.NationalIdTypeLkp == vm.cnicLookupId
                })[0];
                if (angular.isDefined(vm.cnicData))
                    vm.cnic = vm.cnicData.NationalIdentifierValue;
                if (angular.isDefined(vm.ResourceCopy.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonNationalIdentifier)) {
                    vm.ResourceCopy.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonNationalIdentifier.filter(function (item) {
                        if (item.NationalIdTypeLkp && item.NationalIdTypeLkp == vm.cnicLookupId)
                            item.NationalIdentifierValue = vm.cnic;
                    });
                }
                else {
                    vm.ResourceCopy.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonNationalIdentifier = vm.tradeAppDataCopy.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonNationalIdentifier
                }
            }

            vm.submitCommand = function (command, ev) {

                vm.errorControl.validations.required = true;
                //remove any biz rules invalidations if any..
                vm.removeViolatedBizRules();
                vm.errorType = 'dynamic';//set error type back to dynamic 

                vm.verifyPage();
                $timeout(function () { // Chopsoy: vm.page.isValid was being updated after this check has passed. so we have waited for UI hook to perform the validation check
                    if (!vm.page.isValid) {
                        vm.isPageLoading = false;
                        var alert = {
                            title: 'Action Failed Due To Invalid Fields',
                            message: 'Application could not proceed to submit due to some invalid fields. Please rectify the invalid fields in order to be able to submit the Loan Application.',
                        };
                        vm.showSimpleDialog(alert.title, alert.message);
                        return;//don't proceed with submitting
                    }
                    else {
                        showCommentDialog(command, ev);
                        return;
                    }
                }, 500);
            }

            vm.viewEcib = function () {
                if (vm.resource.TmxCustomerMaster[0].NationalIdentifierValue) {
                    window.open(ENV.ecibURL + vm.resource.TmxCustomerMaster[0].NationalIdentifierValue + '.pdf', '_blank');
                }
                else {
                    ToastService.showCustomToast('error', 'CNIC not found');
                }

            }


            vm.formatDateOfBirth = function (dateTime) {
                if (dateTime) {
                    //var date= new Date(dateTime + 'Z');
                    var date = new Date(dateTime);
                    var month = date.getUTCMonth() + 1; //months from 1-12
                    var day = date.getUTCDate();
                    var year = date.getUTCFullYear();
                    return day + "/" + month + "/" + year;
                }
                else {
                    return 'N/A';
                }
            }

            vm.goto = function (state) {

                if (angular.isDefined(state)) {
                    $state.searchClear = true;
                    $state.go("private.inbox");
                }
                else {
                    $state.searchClear = true;
                    $state.reload($state.current);
                }
            }

            vm.getStatus = function () {
                var ret_status = STATUS.NEW;
                if (exists(vm.resource) && exists(vm.resource.TradeStatusLkp)) {
                    var status = vm.statuses.find(function (item) { return item.LookupId == vm.tradeAppData.TradeStatusLkp });
                    if (exists(status)) {
                        ret_status = status.VisibleValue;
                    }
                }
                return ret_status;
            }

            vm.isNew = function () {
                return vm.getStatus() == STATUS.NEW;
            }

            vm.enableUpdate = function () {
                var status = vm.getStatus();
                return status != "Overdue" && status != "Active" && status != "Approved";
            }

            vm.showFunctionalButton = function () {
                if (vm.resource && vm.resource.Commands && vm.resource.Commands.length > 0) {
                    vm.istabDisabled = false;
                    return true;
                }
                else {
                    vm.istabDisabled = true;
                    return false;
                }
            }

            vm.verifyValidations = function () {

            }

            vm.removeViolatedBizRules = function () {
                vm.bizRulesFailedFields.forEach(function (field) {
                    var bizRuleViolations = field.possibleValidations.all.filter(function (violation) { return violation.name.indexOf("bizRule") > -1; })
                    bizRuleViolations.forEach(function (violation) {
                        field.removeValidationRule(violation.name);
                    });
                });
                vm.bizRulesFailedFields = [];
            }
            vm.replaceUnderscoresWithSpaces = function (value) {
                return value.replace(/_/g, " ");
            }
            //#endregion


            //#region  =========== Child/Dialog Controllers ==================================

            function CommentsDialogController($scope, $mdDialog, $filter, TMX_FINANCE_CONSTANTS, tmxUtility, UsersService, lookupService, ToastService, command, Parameter, Actors, ProcessID, ApplicationId, UserId, TenantName) {
                $scope.RejectionReasonList = [];
                $scope.ActionType = null;
                $scope.TenantName = TenantName;
                $scope.RoleActorList = Actors;
                $scope.isCommentMandatory = vm.isCommentMandatory;


                //initializing Lookup types from Tmx Finance Constant
                var lkupType = TMX_FINANCE_CONSTANTS.LOOKUP_TYPES;

                $scope.removeReason = function (index) {
                    $scope.RejectionReasonList.splice(index, 1);
                }

                $scope.addReason = function () {

                    $scope.RejectionReasonList.push(
                        {
                            "Comments": "",
                            "RemarksLkp": 0,
                            "TransactionId": ApplicationId,
                            "ActionType": null,
                            "UserId": UserId
                        });
                }

                $scope.addReason();
                $scope.command = command;
                $scope.hide = function () {
                    $mdDialog.hide();
                };

                $scope.cancel = function () {
                    $mdDialog.cancel();
                };

                $scope.done = function () {
                    $scope.CommentsDialogController.dialogForm.$submitted = true;
                    if (!$scope.CommentsDialogController.dialogForm.$valid) {
                        ToastService.showCustomToast("error", $filter('translate')("FillRequiredFields"));
                        $scope.CommentsDialogController.dialogForm.$submitted = false;
                        return;
                    }

                    $scope.RejectionReasonList.forEach(function (item) {
                        item.ActionType = $scope.ActionType;
                    });
                    $scope.responseData = {};
                    $scope.responseData.TmxApplicationRemark = $scope.RejectionReasonList;
                    if (tmxUtility.exists($scope.RoleActorList) && $scope.RoleActorList.length > 0) {
                        $scope.responseData.TmxWorkflowReceivingActor = [];
                        $scope.RoleActorList.forEach(actor => (
                            $scope.responseData.TmxWorkflowReceivingActor.push({ ActorRole: actor.HiddenValue, ActorId: actor.SelectedUser })
                        ));
                    }
                    $mdDialog.hide($scope.responseData);
                };

                function InitializeLookups() {
                    $scope.lookups = {};
                    lookupService.getLookupByType(lkupType.RejectionTypes).then(function (response) {
                        $scope.lookups.rejectionReasonLkp = response;
                    });

                    lookupService.getLookupByType(lkupType.CIU_REJECTION_CODES).then(function (response) {
                        $scope.lookups.rejectionCodesLkp = response;
                    });
                    lookupService.getLookupByType(lkupType.YES_NO).then(function (response) {
                        $scope.lookups.yesNoLkp = response;
                    });
                }

                function PopulateRoleUserList() {
                    if (tmxUtility.exists(Actors) && Actors.length > 0) {
                        var roleNames = Actors.map(x => x.ActorRole);
                        let roleNamesString = roleNames.join(',');
                        UsersService.getUserByRoleNames(roleNamesString, vm.tradeAppData.CompanyBranchId).then(function (response) {
                            $scope.RoleActorList = [];
                            if (tmxUtility.exists(response, "status.code") || response.status.code == 200) {
                                roleNames.forEach(name => {
                                    let roleListItem = { HiddenValue: name, VisibleValue: name };
                                    roleListItem.UserList = response.data.filter(x => x.RoleName == name);
                                    $scope.RoleActorList.push(roleListItem);
                                });
                            }
                            else {
                                ToastService.showCustomToast('error', 'Error in getting the users list.')
                                console.log("Error in fetching user list. Response received: ", response);
                            }
                        });
                    }
                }

                (function InitializeDialogController() {
                    InitializeLookups();
                    PopulateRoleUserList();
                })();

            }

            function ManualDeviationDialogController($scope, $mdDialog, $filter, lookupService, UsersService) {
                $scope.UsersList = [];
                $scope.LevelsList = [];
                $scope.isCommentMandatory = vm.isCommentMandatory;
                var data = {};

                lookupService.getByType('USER').then(function (data) {
                    $scope.LevelsList = data;
                });
                $scope.hide = function () {
                    $mdDialog.hide();
                };

                $scope.cancel = function () {
                    $mdDialog.cancel();
                };

                $scope.done = function () {
                    $scope.ManualDeviationDialogController.dialogForm.$submitted = true;
                    if (!$scope.ManualDeviationDialogController.dialogForm.$valid) {
                        ToastService.showCustomToast("error", $filter('translate')("FillRequiredFields"));
                        $scope.ManualDeviationDialogController.dialogForm.$submitted = false;
                        return;
                    }
                    if ($scope.userId) {
                        data.userId = $scope.userId;
                        data.comments = $scope.comments;
                        $mdDialog.hide(data);
                    }
                };

                $scope.levelChange = function (typeId) {
                    if (typeId) {
                        UsersService.getUsersByType(typeId).then(function (response) {
                            $scope.UsersList = response.data;

                        })
                    }
                    else {
                        $scope.userId = null;
                        $scope.UsersList = [];
                    }
                }
            }

            function EvaluationRulesDialogController($scope, $mdDialog, $filter, evaluationData, lookupService, UsersService, showOnlyMessages, tenantName, TenantsList) {

                $scope.vm = {};
                $scope.RulesList = [];
                $scope.showDeviationFields = false;
                $scope.showOnlyMessages = showOnlyMessages;
                $scope.TmxApplicationRemark = [{
                    "Comments": ""
                }];
                $scope.isCommentMandatory = vm.isCommentMandatory;

                if (evaluationData.data && evaluationData.data != null) {
                    for (var key in evaluationData.data) {
                        $scope.RulesList.push({
                            ruleKey: key.toUpperCase(),
                            ruleText: evaluationData.data[key]
                        });
                    }
                    if (evaluationData.data.manualDeviation || (evaluationData.data.warning && evaluationData.data.manualDeviation) || (evaluationData.data.error && evaluationData.data.manualDeviation)) {
                        $scope.showDeviationFields = true;
                    }
                    else if (evaluationData.data.error || evaluationData.data.warning || (evaluationData.data.error && evaluationData.data.warning)) {
                        $scope.showDeviationFields = false;
                    }
                }
                else {
                    if (evaluationData.manualDeviation || evaluationData.warning || evaluationData.error) {
                        Object.keys(evaluationData).forEach(function (key) {
                            $scope.RulesList.push({
                                ruleKey: key.toUpperCase(),
                                ruleText: evaluationData[key]
                            });
                        });
                        if (evaluationData.manualDeviation || (evaluationData.warning && evaluationData.manualDeviation) || (evaluationData.error && evaluationData.manualDeviation)) {
                            $scope.showDeviationFields = true;
                        }
                        else if (evaluationData.error || evaluationData.warning || (evaluationData.error && evaluationData.warning)) {
                            $scope.showDeviationFields = false;
                            if (evaluationData.error)
                                vm.status = "error";
                            else if (evaluationData.warning)
                                vm.status = "warning";
                        }
                    }
                }

                $scope.ok = function () {
                    $mdDialog.hide();
                    if (vm.status == "warning" && !$scope.showOnlyMessages)
                        $state.go("private.inbox");
                };


                function getPropertyValueByHiddenValue(levelsList, hiddenValue, property) {
                    var obj = levelsList.filter(function (item) {
                        return item.HiddenValue == hiddenValue;
                    })[0]
                    return obj[property];
                }

                lookupService.getByType('USER').then(function (data) {
                    $scope.LevelsList = data;
                    $scope.disableLevelList = false;
                    if (TenantsList.SILK == tenantName) {
                        var deviationReceivedLevels = [];
                        var obj = $scope.RulesList.filter(function (item) {
                            return item.ruleKey == 'MANUALDEVIATION'
                        })[0];

                        if (obj && obj.ruleText) {
                            obj.ruleText.forEach(function (item) {
                                deviationReceivedLevels.push(
                                    {
                                        name: item.split(':')[0],
                                        id: getPropertyValueByHiddenValue($scope.LevelsList, item.split(':')[0], 'LookupId'),
                                        sort: getPropertyValueByHiddenValue($scope.LevelsList, item.split(':')[0], 'SortOrder')
                                    }
                                )
                            })

                            if (deviationReceivedLevels.length > 0) {
                                deviationReceivedLevels.sort(function (a, b) { return a.sort - b.sort; });
                                $scope.vm.levelId = deviationReceivedLevels[0] ? deviationReceivedLevels[0].id : null;
                                $scope.levelChange($scope.vm.levelId);
                                $scope.disableLevelList = true;
                            }
                        }
                    }
                });

                $scope.levelChange = function (typeId) {
                    if (typeId) {
                        UsersService.getUsersByType(typeId).then(function (response) {
                            $scope.UsersList = response.data;

                        })
                    }
                    else {
                        $scope.vm.userId = null;
                        $scope.UsersList = [];
                    }
                }

                $scope.hide = function () {
                    $mdDialog.hide();
                };

                $scope.cancel = function () {
                    $mdDialog.cancel();
                };

                $scope.done = function () {
                    $scope.EvaluationRulesDialogController.dialogForm.$submitted = true;
                    if (!$scope.EvaluationRulesDialogController.dialogForm.$valid) {
                        ToastService.showCustomToast("error", $filter('translate')("FillRequiredFields"));
                        $scope.EvaluationRulesDialogController.dialogForm.$submitted = false;
                        return;
                    }
                    if ($scope.vm.userId) {
                        var responseData = {};
                        responseData.TmxApplicationRemark = $scope.TmxApplicationRemark;
                        responseData.TargetUserId = $scope.vm.userId;
                        $mdDialog.hide(responseData);
                    }

                }
            }

            //#endregion


            //#region  =========== Publishers and Subscribers==================================

            $scope.$on("SelectChangeEvent", function (event, form_name) {

                if (vitasTenants.includes(tenantName) && tmxUtility.checkPermission('Validate Service', 'View') && !vm.hideValidateButton) {
                    vm.disableActionButton1 = true;
                    vm.disableActionButton2 = true;
                }
                else if (TenantsList.SAMBA == tenantName && tmxUtility.checkPermission('Validate Service', 'View')) {
                    vm.disableActionButton1 = true;
                }
                else if (TenantsList.SILK == tenantName && form_name == "slsForm") {
                    $scope.$emit("reloadApplicationData", "");
                }
            });

            $scope.$on("reloadApplicationData", function () {

                vm.slsUpdated = true;
            });

            BroadcastService.subscribe("onGridDataFetch", $scope, function (evt, data) {

                vm.isPageLoading = true;
                var sourceTable = dynamicFormService.mapArray[data.src].table;
                var destinationTable = data.des;
                vm.ResourceCopy = angular.copy(vm.resource);
                vm.page.write(vm.ResourceCopy, false);
                unwrapTradeAppAttributes(vm.ResourceCopy);
                vm.mapresource();
                vm.bindRootObjectsToChildObjects();
                makeArrayToObject(vm.ResourceCopy);
                vm.deleteEmptyObjects();
                objectCleaning(vm.ResourceCopy);
                SetChecklist();
                eval('vm.ResourceCopy.' + destinationTable + ' = vm.ResourceCopy.' + sourceTable);
                loadData(vm.ResourceCopy);
                vm.isPageLoading = false;

            });

            BroadcastService.subscribe('reloadGuarantorData', $scope, function () {
                vm.resource['TmxLoanApplicationToGuarantorMappingDummy[0].TmxGuarantor'] = dynamicFormService.applicationData.TmxLoanApplicationToGuarantorMappingDummy[0].TmxGuarantor;
                vm.ResourceCopy = angular.copy(vm.resource);
                vm.tradeAppDataCopy = angular.copy(vm.tradeAppData);
                formatJsonForPost();
                loadData(vm.resource);
            });

            BroadcastService.subscribe('updateGuarantorData', $scope, function () {
                vm.ResourceCopy = angular.copy(vm.resource);
                vm.tradeAppDataCopy = angular.copy(vm.tradeAppData);
                vm.page.write(vm.ResourceCopy, false);
                formatJsonForPost();
                vm.resource = vm.ResourceCopy;
                dynamicFormService.applicationData = vm.resource;
                $rootScope.selectedTabId = 239;
                loadData(vm.resource);
            });

            BroadcastService.subscribe('addGuarantorData', $scope, function () {
                vm.ResourceCopy = angular.copy(vm.resource);
                vm.tradeAppDataCopy = angular.copy(vm.tradeAppData);
                vm.page.write(vm.ResourceCopy, false);
                console.log(vm.ResourceCopy);

                dynamicFormService.applicationGuarantorMappingData.push(
                    {
                        TmxGuarantor: vm.ResourceCopy['TmxLoanApplicationToGuarantorMappingDummy[0].TmxGuarantor']
                    }
                )
            });

            //#endregion


            //#region ============ Page Initialization============================================

            (function InitializePage() {
                readConfigurations();
                setDataAndState()
                tenantWiseLogic();
                setStatusBasedVariables();
                setButtonsVisiblity();
            })();

            //#endregion


        }]);
})();
